/**
 * Created by Mark on 17/04/2017.
 */



import ApplicationServices from './base-service.js';
import InternationalizationConstants from '../constants/internationalization.js';
import Actions from '../actions/default.js';

class InternationalizationService {

    getTranslations(locale){

        console.log(locale);

        return ApplicationServices.call(InternationalizationConstants.GET_ADMIN_TRANSLATIONS , {language: locale}).then(function(response){

            var translations = {};

            Object.keys(response.translations).map(function(key){
                translations['ui-'+key] = response.translations[key];
            }.bind(this));

            Actions.update(InternationalizationConstants.TRANSLATION_UPDATE , translations);
        });
    }

    getUserTranslations(locale){

        return ApplicationServices.call(InternationalizationConstants.GET_ADMIN_TRANSLATIONS , {language: locale}).then(function(response){

            var translations = {};

            Object.keys(response.translations).map(function(key){
                translations['ui-'+key] = response.translations[key];
            }.bind(this));

            return ApplicationServices.call(InternationalizationConstants.GET_MODULE_TRANSLATIONS , {language: locale}).then(function(response){


                Object.keys(response.translations).map(function(key){
                    translations['module-'+key] = '{index} ' + response.translations[key];
                    translations['no-index-module-'+key] = response.translations[key];
                }.bind(this));


                console.log(translations);
                Actions.update(InternationalizationConstants.TRANSLATION_UPDATE , translations);
            });
        });
    }

}

export default new InternationalizationService();


// WEBPACK FOOTER //
// ./src/services/internationalization-service.js